import React, { createContext, useState } from 'react';
import useProfileService from '../hooks/useProfileService';
import { UserProfile, UserType } from '../services/interfaces';


interface UserContextValue {
  userType: UserType | null;
  userProfile: UserProfile | null;
  setUserType: (type: UserType) => void;
  setUserProfile: (profile: UserProfile) => void;
};

interface UserProviderProps {
  children: React.ReactNode;
};

export const UserContext = createContext<UserContextValue>({
  userType: null,
  userProfile: null,
  setUserType: () => { },
  setUserProfile: () => { },
});

export const UserProvider: React.FC<UserProviderProps> = ({ children }) => {
  const { getProfile, getUserType } = useProfileService();
  const [userType, setUserType] = useState<UserType | null>(getUserType());
  const [userProfile, setUserProfile] = useState<UserProfile | null>(getProfile());

  return (
    <UserContext.Provider value={{ userType, userProfile, setUserType, setUserProfile }}>
      {children}
    </UserContext.Provider>
  );
};
